import { Routes, Route, Link } from "react-router-dom";
import Blogs from "./pages/blogs/Blogs";
import Home from "./pages/Home";
import CreateBlog from "./pages/admin/CreateBlog";
import ViewBlog from "./pages/viewblog/ViewBlog";
import ContactPage from "./pages/contact/ContactPage";
import About from "./pages/about/About";

function App() {
  return (
    <>
      <Routes>
        <Route path='/' element={<Blogs />} />
        <Route path='/portfolio' element={<Home />} />
        <Route path='/blogs/:id' element={<ViewBlog />} />
        <Route path='/admin/create-blog/' element={<CreateBlog />} />
        <Route path='/contact' element={<ContactPage />} />
        <Route path='/about' element={<About />} />
      </Routes>
    </>
  );
}

export default App;
